<template>
  <div
    ref="scrollContainer"
    class="aw-smooth-scrollbar"
    v-click-outside="clickOutside"
  >
    <slot />
  </div>
</template>

<script>
import $ from 'jquery'
import SmoothScrollbar from 'smooth-scrollbar'
import './jquery.dragscroll'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    scrollX: {
      type: Boolean,
      default: false, 
    },
    scrollY: {
      type: Boolean,
      default: false, 
    },
    focusSelector: {
      type: String,
      default: ''
    },
    dragScrollDir: {
      type: String,
      default: 'x' // x, all
    }
  },
  data() {
    return {
      scrollbar: null
    };
  },
  computed: {
    changeDir() {
      return this.scrollY || this.scrollX
    }
  },
  watch: {
    changeDir( newValue ) {
      this.bind()
    },
    focusSelector() {
      if((!this.scrollX && !this.scrollY)  || !this.focusSelector) {
        return
      }
      const $el = $(this.$refs.scrollContainer).find(this.focusSelector)
      const elOffset = $el.offset()
      const offset = this.$scrollContainer.offset()
      // 범위안에 있으면 종료
      if(elOffset.top > offset.top
      && elOffset.top + $el.height() < offset.top + this.$scrollContainer.height()) {
        return
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.scrollbar.scrollIntoView($el.get(0), {
          alignToTop: false
        })
      }, 300)
    }
  },
  created() {
    console.log(this.scrollX, this.scrollY)
    this.defaultOptions = {
      damping: 0.1,
      thumbMinSize: 20,
      renderByPixels: true,
      alwaysShowTracks: false,
      continuousScrolling: false,
      delegateTo: null,
      plugins: {}
    }

  },
  mounted() {
     this.bind()
  },
  methods: {
    clickOutside() {
      this.$content?.removeClass('cur-grab cur-grabbing')
      this.$scrollContainer?.removeClass('hand-scroll')
    },
    bind() {
      if(this.scrollbar) {
        this.unbind()
      }
      if(!this.scrollX && !this.scrollY) return

      this.scrollbar = SmoothScrollbar.init(
        this.$refs.scrollContainer,
        { ...this.defaultOptions, ...this.options, continuousScrolling: !this.scrollY /* 상하스크롤이 아니면 마우스휠 이벤트가 native로 적용 */ }
      )
      this.scrollbar.addListener(this.triggerScroll)      
      this.$scrollContainer = $(this.$refs.scrollContainer)
      this.$scrollContainer.hover(
        (e) => {
          this.$scrollContainer?.removeClass('hand-scroll')
          $(this.$refs.scrollContainer).find('.scrollbar-track').addClass('show')
        },
        (e) => {
          $(this.$refs.scrollContainer).find('.scrollbar-track').removeClass('show')
        }  
      )

      this.$content = this.$scrollContainer.find('.scroll-content > ')

      $(this.$content).dragScroll({
        onStart: () => {
          if(!this.isEnable()) return false
          this.$content.addClass('cur-grab') 
          return true
        },
        onMove: ( position ) => {
          if(!this.isEnable()) return false
          // 드래그시 스크롤 이동 방향
          if(this.dragScrollDir === 'x') { // 좌우만 이동
            this.scrollbar.setPosition( position.left, this.scrollbar.scrollTop /*position.top*/ )
          } else { // 좌우/상하 이동
            this.scrollbar.setPosition( position.left, position.top )
          }
          this.$content.removeClass('cur-grab').addClass('cur-grabbing')  
          return true
        },
        onEnd: () => {
          if(!this.isEnable()) return false
          this.$content.removeClass('cur-grab cur-grabbing')
          return true
        }  
      })


      $(window).on('resize.awss',this.checkLeftScroll)
      this.checkLeftScroll()
      
    },
    isEnable() {

      const isX = (this.scrollbar.limit.x !== Infinity && this.scrollbar.limit.x !== 0)
      const isY = (this.scrollbar.limit.y !== Infinity && this.scrollbar.limit.y !== 0)

      if(this.dragScrollDir == 'x' && !isX) return false

      if(this.dragScrollDir == 'all' && !isX && !isY) return false

      return true

    },
    checkLeftScroll() {
      if(!this.scrollbar?.limit) return
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if(this.scrollbar.limit.x !== Infinity && this.scrollbar.limit.x > 0) {
          this.$scrollContainer.addClass('hand-scroll')
          setTimeout(()=>this.$scrollContainer.removeClass('hand-scroll'),2000)
        }  
      }, 500)      
    },
    triggerScroll( status ) {
      this.$emit('scroll', status)
    },
    unbind() {
      $(this.$content)?.dragScroll('destroy')
      this.$scrollContainer?.off()
      this.scrollbar?.removeListener(this.triggerScroll)
      this.scrollbar?.destroy()
      this.scrollbar = null
      $(window).off('resize.awss')

    }
  },
  destroyed() {
    this.unbind()
  }
};
</script>
<style>
.aw-smooth-scrollbar {
  width: 100%;
  height: 100%;
}
/* smooth scrollbar */
.aw-smooth-scrollbar .scrollbar-thumb { width: 5px; background: #acb2bd;  height: 5px; }
.aw-smooth-scrollbar .scrollbar-track.show { opacity: 0.6;}
.aw-smooth-scrollbar .scrollbar-track { background: transparent; cursor: pointer; z-index: 5}
.aw-smooth-scrollbar .scrollbar-track-x {bottom:-1px;}
.aw-smooth-scrollbar .scrollbar-track-y {right:-1px;}

</style>